import { FileCheck, FlaskConical, Globe, Scale, ShieldCheck } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { ComplianceBadge } from '@marketing/data/compliance';

const MAP: Record<ComplianceBadge['iconKey'], LucideIcon> = {
  lgpd: ShieldCheck,
  cfm: FileCheck,
  lei14510: Globe,
  anvisa: Scale,
  cep: FlaskConical,
};

export function ComplianceIcon({
  iconKey,
  size = 32,
}: {
  iconKey: ComplianceBadge['iconKey'];
  size?: number;
}) {
  const Icon = MAP[iconKey];
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size + 16,
        height: size + 16,
        borderRadius: 12,
        background: 'var(--color-severity-stable-bg)',
        color: 'var(--color-severity-stable-fg)',
      }}
    >
      <Icon size={size} strokeWidth={1.75} aria-hidden="true" />
    </span>
  );
}
